// *******************************************************************************
// Toggle header classes
// *******************************************************************************

const toggleMenuClass = (toggle) => {
  document.body.classList.toggle('is-open-menu', toggle);
  document.body.classList.remove('is-open-language');
  toggleBodyScrollLock(toggle);
};

attachEvent('.hamburger', 'click', () => {
  const isOpen = document.body.classList.contains('is-open-menu');
  toggleMenuClass(!isOpen);

  const menuEle = document.body.querySelector('.menu');
  if (isOpen && menuEle) {
    menuEle.classList.add('is-closed');
    setTimeout(() => menuEle.classList.remove('is-closed'), 600);
  }
});

// *******************************************************************************
// Add class to body after some scroll
// *******************************************************************************
const addScrollingClass = () => {
  const topOffset = document.documentElement.scrollTop || document.body.scrollTop;
  document.body.classList.toggle('is-scrolled', topOffset > 30);
};

let lastScrollTop = 0;
let ticking = false;

// Use a scroll event with requestAnimationFrame for smoother performance
const onScroll = () => {
  if (!ticking) {
    window.requestAnimationFrame(() => {
      addScrollingClass();

      const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      document.body.classList.toggle('is-scrolled-up', currentScrollTop < lastScrollTop);

      lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
      ticking = false;
    });
    ticking = true;
  }
};

// Initialize the function and set the scroll listener
addScrollingClass();
window.addEventListener('scroll', onScroll);
